import { render, staticRenderFns } from "./search-facet-minimal.vue?vue&type=template&id=d160c9ca&"
import script from "./search-facet-minimal.vue?vue&type=script&lang=js&"
export * from "./search-facet-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports